var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2425(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "scale(-1, 1) translate(-20.719551, 1)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(9.661178, 13.612916) scale(-1, 1) translate(-9.661178, -13.612916)",
    d: "M10.2149703,27.225833 C9.99151223,27.225833 9.75814552,27.2155917 9.5135034,27.1916954 C7.25466397,26.9766285 2.28528555,22.2758814 1.1492031,16.1379415 C0.502269607,12.7684389 0.122510303,9.35317917 0.0134623213,5.92397251 C0.00867881623,5.76352581 0.00526202689,5.64404422 0.000820200754,5.5689415 C-0.024203729,4.05345989 0.524172103,2.58437454 1.53632533,1.45536108 C2.18642585,0.689118194 3.1222424,0.222303316 4.12590997,0.163594413 L4.34970967,0.156084142 C11.2820336,-0.0828790367 14.8290026,-0.0487414398 15.853356,0.267372707 C17.495465,0.772950517 19.0788052,2.51294383 19.2421277,3.98837077 C19.3104635,4.59328899 19.3951998,14.7867754 19.2113766,16.8691688 C19.0569377,18.6170138 16.6405843,22.4574934 15.3312706,24.1165806 C14.125144,25.648676 12.8804076,27.225833 10.2149703,27.225833 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.280449, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-8.280449, -21.000000) translate(0.280449, 13.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square",
    x1: 2.05161287,
    y1: 2.87724113,
    x2: 15.01346,
    y2: 21.3865535
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2425);
export default __webpack_public_path__ + "static/media/24-25.717c9bc84220fcf8fc31ec4591d88ffc.svg";
export { ForwardRef as ReactComponent };